import { render, staticRenderFns } from "./ProofPreview.vue?vue&type=template&id=2b92c939&scoped=true"
import script from "./ProofPreview.vue?vue&type=script&lang=js"
export * from "./ProofPreview.vue?vue&type=script&lang=js"
import style0 from "./ProofPreview.vue?vue&type=style&index=0&id=2b92c939&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b92c939",
  null
  
)

export default component.exports